import 'client-only';
import { logger } from '@curology/logger/client';

import { type Brand } from '@/consts/brands';
import { post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const getOS = () => {
  const ua = navigator.userAgent;

  if (/windows phone/i.test(ua)) return 'Windows Phone';
  if (/windows/i.test(ua)) return 'Windows';
  if (/android/i.test(ua)) return 'Android';
  if (/iPad|iPhone|iPod/.test(ua)) return 'iOS';
  if (/mac/i.test(ua)) return 'macOS';
  if (/linux/i.test(ua)) return 'Linux';

  return 'Unknown';
};

const getBrowser = () => {
  const ua = navigator.userAgent;

  if (/chrome|crios/i.test(ua) && !/edge|edg/i.test(ua)) return 'Chrome';
  if (/safari/i.test(ua) && !/chrome/i.test(ua)) return 'Safari';
  if (/firefox|fxios/i.test(ua)) return 'Firefox';
  if (/edg/i.test(ua)) return 'Edge';

  return 'Unknown';
};

const getNetworkInfo = () => {
  const nav = navigator as any;
  const connection =
    nav.connection || nav.mozConnection || nav.webkitConnection;

  return {
    supported: !!connection,
    connectionType: connection?.effectiveType ?? null,
    downlinkMbps: connection?.downlink ?? null,
    roundTripTime: connection?.rtt ?? null,
    saveData: connection?.saveData ?? null,
  };
};

const getDeviceInfo = () => {
  return {
    browser: getBrowser(),
    os: getOS(),
    isMobile: /Mobi|Android/i.test(navigator.userAgent),
    userAgent: navigator.userAgent,
    ramGB: (navigator as any).deviceMemory,
    cpuCores: navigator.hardwareConcurrency,
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      pixelRatio: window.devicePixelRatio,
      orientation: window.screen.orientation?.type,
    },
    touch: 'ontouchstart' in window,
    networkInfo: getNetworkInfo(),
  };
};

const sendLogsToDatadog = async (
  brand: Brand,
  eventName: string,
  data: Record<string, any>,
  logType: string = 'info',
): Promise<void> => {
  data.deviceInfo = getDeviceInfo();

  try {
    await post(urls[brand].api.logging.datadog, {
      eventName,
      data,
      logType,
    });
  } catch (err) {
    logger.log(`Logging to datadog was not possible: ${err}`);
  }
};

export const Loggingservice = {
  sendLogsToDatadog,
};
